<template>
  <div class="register">
    <header class="header">
      <div class="header-container">
        <div class="header-logo">
          <div class="logo">
            <router-link to="/home">
              <img :src="config.logo1" />
            </router-link>
          </div>
          <img :src="require('@/assets/images/cifuFont.png')" class="slogin"/>
        </div>
      </div>
    </header>
    <main class="main" :style="{
      background: `url(${login_bg_image}) no-repeat`,
      backgroundSize: 'cover'
    }">
      <div class="register-box">
        <div class="register-title">
          <span class="register-title-text">登录</span>
          <span class="register-title-text2">Sign in and getting started</span>
        </div>
        <el-form class="form" ref="formRef" :model="form" :rules="rules" label-position="top">
          <el-form-item prop="account">
            <div class="form-item-title">账号</div>
            <el-input type="text" class="input" v-model="form.account" placeholder="请输入手机号码" maxlength="11">
              <template slot="prepend">+86</template>
            </el-input>
          </el-form-item>
          <el-form-item prop="captcha">
            <div class="form-item-title">验证码</div>
            <div class="flex-space-between">
              <el-input type="text" class="input" v-model="form.captcha" placeholder="请输入验证码" />
              <el-button class="getCode" type="warning" :disabled="countdown > 0 || !isPhoneValid" @click="getVerificationCode">
                {{ countdown > 0 ? `${countdown}s后重新获取` : "获取验证码" }}
              </el-button>
            </div>
          </el-form-item>
          <div class="form-item">
            <div class="form-item-label">
              <div class="">
                <span>没有账号？</span>
                <router-link to="/register" style="margin: 0; color: #663301">立即注册</router-link>
              </div>
            </div>
          </div>
          <div class="form-item">
            <div class="btn-group">
              <el-button class="btn btn-primary" :loading="loading" @click="login">登 录</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </main>
    <footer class="footer">
      <div class="footer-container">
        <div class="footer-copyright">
          <span class="p">Copyright 2014 owecn.com All Rights Reserved</span>
          <span class="p">北京慈福公益基金委员会版权所有</span>
        </div>
        <div class="footer-link">
          <a class="p" href="https://beian.miit.gov.cn/" target="_blank">京ICP备10028793号</a>
          <a class="p" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010102002189" target="_blank"
            >京公安网备 11010102002189号</a
          >
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import CifuAPI from "@/utils/api";
import { mapState } from "vuex";

export default {
  name: "Login",
  data() {
    // 自定义验证函数 - 用户协议
    const validateAgreement = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请阅读并同意用户协议和隐私政策"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      login_bg_image: '',
      countdown: 0, // 倒计时秒数
      timer: null, // 定时器
      form: {
        account: "",
        captcha: "",
        checked: false,
      },
      rules: {
        account: [
          { required: true, message: "请输入手机号码", trigger: ["blur", "change"] },
          { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号码", trigger: ["blur", "change"] },
        ],
        captcha: [{ required: true, message: "请输入验证码", trigger: ["blur", "change"] }],
        checked: [{ validator: validateAgreement, trigger: ["blur", "change"] }],
      },
    };
  },
  created() {
    this.getConfig();
  },
  computed: {
    // 验证手机号是否有效
    isPhoneValid() {
      return /^1[3-9]\d{9}$/.test(this.form.account);
    },
    ...mapState(["config", "platform"])
  },
  methods: {
    async getConfig() {
      let res = await CifuAPI.getConfig()
      if (res.code == 1) {
        this.login_bg_image = res.data.login_bg_image
      }
    },
    // 获取验证码
    async getVerificationCode() {
      if (!this.isPhoneValid) {
        this.$message.error("请输入正确的手机号码");
        return;
      }

      try {
        // 调用API获取验证码
        const res = await CifuAPI.getSmsCode({
          mobile: this.form.account,
          event: 'mobilelogin'
        });
        if (res.code == 1) this.$message.success("验证码已发送");
        // 开始倒计时
        this.startCountdown();
      } catch (error) {
        return false
      }
    },
    // 开始倒计时
    startCountdown() {
      this.countdown = 60; // 设置60秒倒计时
      this.timer = setInterval(() => {
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          return;
        }
        this.countdown--;
      }, 1000);
    },
    async login() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.submit();
        }
      });
    },
    async submit() {
      const res = await CifuAPI.login({
        mobile: this.form.account,
        captcha: this.form.captcha,
      });
      if (res.code == 1) {
        this.$store.dispatch("login", {
          token: res.data.userinfo.token,
          userInfo: res.data.userinfo,
        });
        this.$router.push("/home");
      }
    },
  },
  // 组件销毁时清除定时器
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>

<style scoped>
.main{
  width: 100%;
  min-width: 1400px;
  display: flex;
  align-items: center;
  min-height: calc(100vh - 300px);
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.form-item-label {
  padding-bottom: 18px;
}
.getCode {
  margin-left: 10px;
  width: 180px;
}
.getCode:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}
.input {
  font-size: 18px;
}
.slogin{
  width: 346px;
}
.el-button--default,
.el-button--small,
.el-button--primary {
  background: #fbce00 !important;
  color: #663301 !important;
}
/* ::v-deep .el-button--primary{
  background: #fbce00 !important;
  color: #663301 !important;
} */
</style>
